import React from 'react';
import {
  Box,
  Card,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Toolbar,
  Typography,
} from '@mui/material';
import MeetingsTableHead from './MeetingsTableHead';

function MeetingsSkeleton() {
  return (
    <Box>
      <Stack direction="row" alignItems="center" mb={3}>
        <Typography variant="pageTitle">Meetings</Typography>
        <Skeleton variant="circular" width={20} height={20} sx={{ ml: 1 }} />
        <Skeleton
          animation="wave"
          variant="text"
          width={120}
          height={20}
          sx={{ display: 'inline-block', ml: 1, verticalAlign: 'middle' }}
        />
      </Stack>

      <Card>
        <Toolbar
          className="border-bottom"
          sx={{
            px: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              justifyContent: { xs: 'space-between', sm: 'space-between', md: 'flex-end' },
              mb: { xs: 2, sm: 2, lg: 0 },
              alignItems: 'center',
              width: { lg: 'auto', sm: '100%' },
            }}
          >
            <Skeleton variant="rounded" width={140} height={36} />
          </Box>
        </Toolbar>

        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table sx={{ tableLayout: 'fixed', minWidth: 650 }}>
            <MeetingsTableHead />

            <TableBody>
              {Array.from({ length: 3 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="80%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="70%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="60%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="rounded" width="80%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="50%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="rounded" width="70%" height={24} />
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 2 }}>
                    <Stack direction="row" gap={1} justifyContent="flex-end">
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
}

export default MeetingsSkeleton;
